import React, { MouseEvent, KeyboardEvent, useState } from "react";
import classNames from "classnames";
import styles from "./style.module.scss";
import { UIButton, UIText } from "src/components/uIKit";
import Accordion from "src/components/accordion/Accordion";
import { images } from "src/assets/images/images";
import { resetPopupInfo } from "src/redux/slices/popupSlice/popupSlice";
import { useAppDispatch } from "src/hooks/useRedux";

interface FAQContentProps {
  subTitle?: string;
  body: string;
  strings?: any;
  okBtnText?: string;
}

const FAQContent: React.FC<FAQContentProps> = ({
  subTitle,
  body,
  strings,
  okBtnText,
}) => {
  const dispatch = useAppDispatch();
  const [openAccordion, setOpenAccordion] = useState<number | null>(null);

  const onSubmit = (e: MouseEvent<HTMLButtonElement> | KeyboardEvent<HTMLButtonElement>) => {
    // check if the event is a click event and the detail is 0 (triggered by keyboard)
    // after click event using the keyboard the keyup is also triggered 
    // so we want to close the popup only on the end of the pressing cycle
    if (e.type === 'click' && e.detail === 0) {
      return; // Skip `onClick` if triggered from keyboard
    }
    dispatch(resetPopupInfo());
  };

  const toggleAccordion = (num: number) => {
    setOpenAccordion(openAccordion === num ? null : num);
  };

  return (
    <div className={styles.errorSubTitleWrapper}>
      <div>
        <div className={styles.mBottom}>
          {subTitle && (
            <UIText tabIndex={0} text={subTitle} size={22} weight={500} />
          )}
        </div>

        <UIText
          tabIndex={0}
          text={body}
          size={18}
          weight={400}
          style={classNames(styles.cardSubTitle, styles.flex1)}
        />
        <br />
        <br />
        <br />

        {strings && (
          <UIText
            tabIndex={0}
            text={strings.questionsTitle}
            size={22}
            weight={500}
          />
        )}
        <br />
        <br />
        {strings && (
          <div className={styles.faqAccordionWrapper}>
            {strings && [1, 2, 3, 4, 5].map((num) => {
              const questionKey = `question${num === 1 ? 'One' : num === 2 ? 'Two' : num === 3 ? 'Three' : num === 4 ? 'Four' : 'Five'}`;
              const answerKey = `answer${num === 1 ? 'One' : num === 2 ? 'Two' : num === 3 ? 'Three' : num === 4 ? 'Four' : 'Five'}`;
              
              return strings[questionKey] ? (
                <Accordion
                  key={num}
                  route={""}
                  index={num}
                  title={strings[questionKey]}
                  isDone={true}
                  accordionIcon={images.question}
                  isOpen={openAccordion === num}
                  onToggle={() => toggleAccordion(num)}
                >
                  <UIText
                    tabIndex={0}
                    text={strings[answerKey]}
                    size={16}
                    weight={400}
                  />
                </Accordion>
              ) : null;
            })}
            <div className={styles.buttonWrapepr}>
              {okBtnText && <UIButton title={okBtnText} onSubmit={onSubmit} />}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQContent;
